import React, { useState } from "react";
import { QRCodeSVG } from "qrcode.react";
import { Smartphone } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";

const isMobileDevice = () =>
  typeof navigator !== "undefined" && /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

export const AppBadgeLink = ({ href, badgeSrc, badgeAlt, storeName, className, imgClassName, testId }) => {
  const [open, setOpen] = useState(false);

  const handleClick = (e) => {
    if (isMobileDevice()) return;
    e.preventDefault();
    setOpen(true);
  };

  return (
    <>
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        onClick={handleClick}
        data-testid={testId}
        aria-label={badgeAlt}
        className={className}
      >
        <img src={badgeSrc} alt={badgeAlt} className={imgClassName} />
      </a>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent
          className="max-w-sm bg-[var(--ptt-ink)] text-white border border-white/15 rounded-none p-8"
          data-testid="app-qr-dialog"
        >
          <DialogHeader>
            <div className="flex items-center gap-2 text-[var(--ptt-teal)]">
              <Smartphone size={16} />
              <span className="font-mono-tech text-[10px] uppercase tracking-widest">Scan with your phone</span>
            </div>
            <DialogTitle className="font-display text-2xl font-bold text-white mt-1">
              Get PTT NZ on {storeName}
            </DialogTitle>
            <DialogDescription className="text-white/60 text-sm">
              Point your phone&apos;s camera at the code below to open the PTT NZ app listing on {storeName}.
            </DialogDescription>
          </DialogHeader>
          <div className="bg-white p-5 mx-auto" data-testid="app-qr-code">
            <QRCodeSVG value={href} size={200} bgColor="#ffffff" fgColor="#0a1f1c" level="M" />
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default AppBadgeLink;
